import { Group, Paper, Text, ThemeIcon } from '@mantine/core';
import styles from './Firm.module.css';

const StatCard = ({
  stat,
}: {
  stat: {
    title: string;
    value: string;
    icon: React.ReactNode;
    detail?: React.ReactNode;
    subtitle?: string;
  };
}) => {
  return (
    <Paper withBorder p='md' radius='md' key={stat.title}>
      <Group justify='apart'>
        <ThemeIcon
          color='gray'
          variant='light'
          style={{}}
          size={38}
          radius='md'
        >
          {stat.icon}
        </ThemeIcon>
        <div>
          <Text
            c='dimmed'
            tt='uppercase'
            fw={700}
            fz='xs'
            className={styles.label}
          >
            {stat.title}
          </Text>
          <Text fw={700} fz='xl'>
            {stat.value}
          </Text>
          {stat.subtitle && (
            <Text c='dimmed' fz='xs' mt={4}>
              {stat.subtitle}
            </Text>
          )}
        </div>
      </Group>
      {stat.detail ?? null}
    </Paper>
  );
};

export default StatCard;
